import {observer} from "mobx-react";
import React from "react";
import {useStore} from "../../../../../../../hooks";
import {SuccessfulModal} from "../../../../../../../elements";

export const GeneralMessageModal = observer(() => {
  const { marketingStore } = useStore();
  const { modal } = marketingStore;
  
  return (
    <SuccessfulModal
      isOpen={modal.generalMessageModal}
      icon="check_circle"
      onClose={() => modal.onConfirm("generalMessageModal")}
      title={modal.title}
      subtitle={modal.message}
      height="200px"
      width="500px"
      zIndex={true}
    />
  );
});
